import { Company } from "./company";

export class Companies extends Array<Company> {
  constructor(companies?: Company[]) {
    super();
    if (companies instanceof Array)
      companies.forEach((company) => this.push(company));
  }

  public get(companyId?: number | null): Company | undefined {
    return this.find((company) => company.id == companyId);
  }

  public update(newCompany: Company): Companies {
    if (this.get(newCompany.id) === undefined)
      return new Companies([...this, newCompany]);
    return new Companies(
      this.map((company) =>
        company.id === newCompany.id ? newCompany : company,
      ),
    );
  }

  public append(newCompanies: Companies): Companies {
    return new Companies([
      ...this.filter((company) => newCompanies.get(company.id) === undefined),
      ...newCompanies,
    ]);
  }
}
